import React, { Component } from "react";
import { connect } from "react-redux";
import CustomBoardGiro from "../../../components/CustomBoardGiro";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../components/CustomText";
import Color from "../../../../utils/Color";
import Grid from "@material-ui/core/Grid";
import CustomTextInput from "../../../components/CustomTextInput";
import CustomButton from "../../../components/CustomButton";
import * as selector from "../../../../common/selectors";
import * as enrolGIRONowSelector from "../../../../common/selectors/enrolGIRONow";
import * as enrolGIRONowAction from "../../../../common/actions/enrolGIRONow";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import LoadingOverlay from "../../../components/LoadingOverlay";
import CustomPaper from "../../../components/CustomPaper";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";
import Image from "../../../../assets";
import CustomBoardSelectEnrolment from "../../../components/CustomBoardSelectEnrolment";
import _ from "lodash";
import CustomEnrolGiroNowV2 from "../../../components/CustomEnrolGiroNowV2";
import MisMatch from "../MisMatch";
import Helper from "../../../../utils/Helper";
import OpenFile from "../OpenFile";
import CustomTitleTextInput from "../../../components/CustomTitleTextInput";
import CustomToast from "../../../components/CustomToast";
import AuthManager from "../../../../utils/AuthManager";

const policyInfo = {
  policyNo: "M0001033",
  productName: "Commercial Motor",
  startDate: "31/08/2020",
  endDate: "30/09/2020",
  renewalPremium: "1,343.15",
};

const screenW = window.screen.width + "px";
const screenH = "450" + "px";

class GiroReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
      width: 0,
      localPolicyNo: "",
      localStatus: "",
      localNric: "",
      localPremium: "",
      localIsRecurring: false,
      localProduct: "",
      localCoveragePeriod: "",
      localStatusLabel: "",
      localMsg: "",
      checkedA: false,
      localShowRecurringCheckBox: false,
      loadingToReddot: false,
      localErrorCode: "",
      localErrorMsg: "",
      id: "",
      getGiroDataAction: true,
      attachFileFront: [],
      attachFileBack: [],
      payorName: "",
      payorNric: "",
      payorRelationship: "",
      nric: "",
      relationship: "",
      misMatchYes: false,
      misMatchNo: false,
      attachedFile: [],
      openCustomToast: "",
      isLogin: false,
      callBackLoading: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    AuthManager.retrieveToken().then((value) => {
      if (value) {
        this.setState({ isLogin: true });
        localStorage.setItem("EnrolGiroFooter", "false");
        console.log("asdsd");
      } else {
        localStorage.setItem("EnrolGiroFooter", "true");
      }
    });

    window.addEventListener("resize", this.updateWindowDimensions);
    var iD = this.getUrlVars()["id"];

    this.setState({ id: iD });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { getGiroCallBack, submitGiro } = this.props;
    if (this.state.id !== "" && this.state.getGiroDataAction === true) {
      getGiroCallBack(this.state.id);
      this.setState({ getGiroDataAction: false });
      this.setState({ callBackLoading: true });
    }
    if (prevProps.getGiroCallBackData !== this.props.getGiroCallBackData) {
      const data = enrolGIRONowSelector.getGiroCallBackDataData(
        this.props.getGiroCallBackData
      );
      const status = enrolGIRONowSelector.getGiroCallBackStatus(data);
      const errorCode = enrolGIRONowSelector.getGiroCallBackDataErrorCode(data);
      const errorMsg = enrolGIRONowSelector.getGiroCallBackDataErrorMessage(
        data
      );
      if (status === false) {
        if(window.localStorage.getItem("GiroFlow") === "1"){
        this.props.history.push(
          "/GiroStatus?status=fail&ErrorCode=" +
            errorCode +
            "&ErrorMessage=" +
            errorMsg
        );}
        if(window.localStorage.getItem("GiroFlow") === "2"){
          if(window.localStorage.getItem("MyToken")){
            window.location.href = process.env.REACT_APP_TIQ_BASE_URL + `/#/PaymentResult`;
          }else{
            this.props.history.push("/PaymentStatus");
          }
        }
      } else {
        this.setState({ callBackLoading: false });
        
        // Auto-enrol for regular users (isThirdParty = false)
        const isThirdParty = enrolGIRONowSelector.getGiroCallBackDataIsThirdParty(data);
        if (!isThirdParty) {
          this.autoEnrolForRegularUser(data);
        }
      }
    }

    if (prevProps.submitGiroData !== this.props.submitGiroData) {
      const success = enrolGIRONowSelector.submitGiroDataSuccess(
        this.props.submitGiroData
      );
      if (success) {
        const data = enrolGIRONowSelector.submitGiroDataData(
          this.props.submitGiroData
        );
        const redirectUrl = enrolGIRONowSelector.submitGiroDataRedirectUrl(
          data
        );
        console.log("redirectUrl", redirectUrl);
        if(window.localStorage.getItem("GiroFlow") === "2" && redirectUrl.indexOf("GiroStatus") === 1){
          if(window.localStorage.getItem("MyToken")){
            window.location.href = process.env.REACT_APP_TIQ_BASE_URL + `/#/PaymentResult`;
          }else{
            this.props.history.push("/PaymentStatus");
          }
          return;
        }
        window.location.href = redirectUrl;
      }
    }
  };

  autoEnrolForRegularUser = (data) => {
    const refNo = enrolGIRONowSelector.getGiroCallBackDataDDAReferenceNo(data);
    const tranRefNo = enrolGIRONowSelector.getGiroCallBackDataTransactionReferenceNo(data);
    const isThirdParty = enrolGIRONowSelector.getGiroCallBackDataIsThirdParty(data);
    
    // Auto-enrol with empty payor details and no mismatch
    this.props.submitGiro(
      refNo,
      tranRefNo,
      "", // payorName
      "", // payorNric
      "", // payorRelationship
      [], // attachedFile
      isThirdParty,
      false // isMatch - no mismatch for auto-enrol
    );
  };

  getUrlVars() {
    var url = window.location.href,
      vars = {};
    url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      key = decodeURIComponent(key);
      value = decodeURIComponent(value);
      vars[key] = value;
    });
    return vars;
  }

  onClickLetGo = () => {
    //this.onClickPayRenewal();
    this.props.history.push("/EnrolGiro");
  };

  onClickEnrolNow = () => {
    this.props.history.push("/EnrolmentStatus");
  };

  onClickHere = () => {};

  handleChangeCheckedA = (event) => {
    this.setState({ checkedA: event.target.checked });
  };

  retryEnrol = () => {
    this.props.history.push("/EnrolGiro");
  };

  onClickMisMatchYes = () => {
    this.setState({ misMatchYes: true });
  };
  onClickMisMatchNo = () => {
    this.setState({ misMatchNo: true });
  };

  handleCloseCustomToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ openCustomToast: false });
  };

  onClickNext = () => {
    console.log("attachFile", this.state.attachFileBack);
    console.log("attachFile", this.state.attachFileFront);
    const { submitGiro } = this.props;
    const {
      payorName,
      payorNric,
      payorRelationship,
      attachFileFront,
      attachFileBack,
      attachedFile,
      misMatchYes,
      misMatchNo,
    } = this.state;

    let tempAttachFile;

    if (!_.isEmpty(attachFileFront) && !_.isEmpty(attachFileBack)) {
      tempAttachFile = attachFileFront.concat(attachFileBack);
      //tempAttachFile.push(attachFileFront);
      // tempAttachFile.push(attachFileBack);
      console.log("tempAttachFile", tempAttachFile);
    }
    if (misMatchYes === true) {
      if (attachFileFront.length === 0 && attachFileBack.length === 0) {
        this.setState({
          openCustomToast: true,
          toastMessage: "NRIC front and back is required",
        });
        return;
      }

      if (attachFileFront.length === 0) {
        this.setState({
          openCustomToast: true,
          toastMessage: "NRIC front is required",
        });
        return;
      }

      if (attachFileBack.length === 0) {
        this.setState({
          openCustomToast: true,
          toastMessage: "NRIC back is required",
        });
        return;
      }
    }

    if (misMatchNo === true) {
      if (payorName === "" && payorNric === "" && payorRelationship === "") {
        this.setState({
          openCustomToast: true,
          toastMessage: "Pleas answer the following details to proceed.",
        });
        return;
      }

      if (payorName === "") {
        this.setState({
          openCustomToast: true,
          toastMessage: "Payor's Name is required",
        });
        return;
      }
      if (payorNric === "") {
        this.setState({
          openCustomToast: true,
          toastMessage: "NRIC/FIN NO is required.",
        });
        return;
      }
      if (payorRelationship === "") {
        this.setState({
          openCustomToast: true,
          toastMessage: "Their relationship to you is required.",
        });
        return;
      }
    }

    const data = enrolGIRONowSelector.getGiroCallBackDataData(
      this.props.getGiroCallBackData
    );
    const refNo = enrolGIRONowSelector.getGiroCallBackDataDDAReferenceNo(data);
    const tranRefNo = enrolGIRONowSelector.getGiroCallBackDataTransactionReferenceNo(
      data
    );
    const isThirdParty = enrolGIRONowSelector.getGiroCallBackDataIsThirdParty(
      data
    );

    const isMatch = isThirdParty ? (misMatchYes ? true : false) : false;

    submitGiro(
      refNo,
      tranRefNo,
      payorName,
      payorNric,
      payorRelationship,
      tempAttachFile,
      isThirdParty,
      isMatch
    );
  };

  renderChildrenV2 = () => {
    const { classes } = this.props;
    const {
      policyNo,
      isOnClickNext,
      errorMsg,
      error,
      attachFileFront,
      attachFileBack,
      nric,
      payorName,
      relationship,
      toastMessagePayorName,
      toastMessagePayorNRIC,
      toastMessagePayorRelationship,
      type,
      payorNric,
      payorRelationship,
      isLogin,
    } = this.state;
    console.log(
      "this.props.getGiroCallBackData",
      this.props.getGiroCallBackData
    );
    const data = enrolGIRONowSelector.getGiroCallBackDataData(
      this.props.getGiroCallBackData
    );
    const bankAccNo = enrolGIRONowSelector.getGiroCallBackDataBankAccountNo(
      data
    );
    const refNo = enrolGIRONowSelector.getGiroCallBackDataDDAReferenceNo(data);
    const tranRefNo = enrolGIRONowSelector.getGiroCallBackDataTransactionReferenceNo(
      data
    );
    const isThirdParty = enrolGIRONowSelector.getGiroCallBackDataIsThirdParty(
      data
    );
    const orderNumber = enrolGIRONowSelector.getGiroCallBackDataOrderNumber(
      data
    );
    const renewalPremium = enrolGIRONowSelector.getGiroCallBackDataRenewalPremium(
      data
    );

    window.localStorage.setItem("orderNumber",orderNumber);

    const onChangePayorName = (event) => {
      this.setState({ payorName: event.target.value });
    };

    const onChangeNRIC = (event) => {
      this.setState({ payorNric: event.target.value });
    };

    const onChangeRelationship = (event) => {
      this.setState({ payorRelationship: event.target.value });
    };

    const onSuccessUploadFile = (files, type) => {
      const { attachFileFront, attachFileBack } = this.state;
      if (type === "front") {
        this.setState({
          attachFileFront: attachFileFront.concat({
            FileName: _.get(files, ["0", "name"], ""),
            FileType: _.get(files, ["0", "src", "file", "type"], ""),
            FileData: _.get(files, ["0", "src", "base64"], ""),
            FileSize: _.get(files, ["0", "size"], 0),
          }),
        });
      } else {
        this.setState({
          attachFileBack: attachFileBack.concat({
            FileName: _.get(files, ["0", "name"], ""),
            FileType: _.get(files, ["0", "src", "file", "type"], ""),
            FileData: _.get(files, ["0", "src", "base64"], ""),
            FileSize: _.get(files, ["0", "size"], 0),
          }),
        });
      }
      this.setState({
        openCustomToast: false,
        toastMessage: "",
      });
    };

    const onFailureUploadFile = (error) => {
      let message = "";
      if (error === "unsupportedFileType") {
        message = "Unsupported file type";
      } else if (error === "maxSizeExceeded") {
        message = "Maximum size exceeded";
      } else if (error === "multipleMaxSizeExceeded") {
        message = "Multiple maximum size exceeded";
      } else if (error === "multipleMaxCountExceeded") {
        message = "Multiple maximum count exceeded";
      } else if (error === "multipleNotAllowed") {
        message = "Multiple not allowed";
      }

      this.setState({
        openCustomToast: true,
        toastMessage: message,
      });
    };

    const onUploadAttachFile = (type) => {
      return (
        <OpenFile
          onSuccess={onSuccessUploadFile}
          onError={onFailureUploadFile}
          type={type}
          isLogin={this.state.isLogin}
        />
      );
    };

    const onClickDeleteAttachFile = (type) => {
      if (type === "front") {
        this.setState({ attachFileFront: [] });
      } else {
        this.setState({ attachFileBack: [] });
      }
    };

    const renderUploadFrontContainer = () => {
      if (!_.isEmpty(attachFileFront)) {
        if (window.innerWidth < 600) {
          return (
            <Grid
              xs={12}
              className={
                isLogin
                  ? classes.uploadNRICPaperisLogin
                  : classes.uploadNRICPaper
              }
            >
              {!_.isEmpty(attachFileFront)
                ? attachFileFront.map((item, index) => {
                    return (
                      <Grid
                        container
                        key={index}
                        direction={"row"}
                        alignItems={"center"}
                        justify={"space-between"}
                      >
                        <Grid item>
                          <Grid container direction={"column"}>
                            <Grid item>
                              <div
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  //width: "13rem",
                                }}
                              >
                                <CustomText
                                  design={classes.fileNameTextStyle}
                                  style={{ wordWrap: "break-word" }}
                                >
                                  {item.FileName}
                                </CustomText>
                              </div>
                            </Grid>
                            <Grid item>
                              <CustomText design={classes.fileSizeTextStyle}>
                                {Helper.convertByte(item.FileSize)}
                              </CustomText>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item>
                          {!_.isEmpty(attachFileFront) ? (
                            <img
                              src={Image.whiteBin}
                              className={classes.deleteIconStyle}
                              onClick={() => onClickDeleteAttachFile("front")}
                            />
                          ) : (
                            false
                          )}
                        </Grid>
                      </Grid>
                    );
                  })
                : false}
            </Grid>
          );
        } else {
          return (
            <Grid
              className={
                isLogin
                  ? classes.uploadNRICPaperisLogin
                  : classes.uploadNRICPaper
              }
            >
              <Grid
                container
                direction={"row"}
                justify={"space-between"}
                alignItems={"center"}
              >
                <Grid item>
                  {!_.isEmpty(attachFileFront)
                    ? attachFileFront.map((item, index) => {
                        return (
                          <div
                            key={index}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <div
                              style={
                                item.FileName.length > 70 &&
                                !window.innerWidth > 600
                                  ? {
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      width: "20rem",
                                    }
                                  : null
                              }
                            >
                              <CustomText
                                design={classes.fileNameTextStyle}
                                style={
                                  item.FileName.length > 70
                                    ? { wordWrap: "break-word" }
                                    : null
                                }
                              >
                                {item.FileName}
                              </CustomText>
                            </div>

                            {/* <CustomText design={classes.fileSizeTextStyle}>
                              {Helper.convertByte(item.FileSize)}
                            </CustomText> */}
                          </div>
                        );
                      })
                    : false}
                </Grid>
                <Grid
                  item
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                  }}
                >
                  {!_.isEmpty(attachFileFront)
                    ? attachFileFront.map((item, index) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginRight: 25,
                            }}
                          >
                            <CustomText design={classes.fileSizeTextStyle}>
                              {Helper.convertByte(item.FileSize)}
                            </CustomText>
                          </div>
                        );
                      })
                    : false}
                  {!_.isEmpty(attachFileFront) ? (
                    <img
                      src={Image.whiteBin}
                      className={classes.deleteIconStyle}
                      onClick={() => onClickDeleteAttachFile("front")}
                    />
                  ) : (
                    false
                  )}
                </Grid>
              </Grid>
            </Grid>
          );
        }
      }
    };

    const renderUploadBackContainer = () => {
      if (!_.isEmpty(attachFileBack)) {
        if (window.innerWidth < 600) {
          return (
            <Grid
              className={
                isLogin
                  ? classes.uploadNRICPaperisLogin
                  : classes.uploadNRICPaper
              }
            >
              {!_.isEmpty(attachFileBack)
                ? attachFileBack.map((item, index) => {
                    return (
                      <Grid
                        container
                        key={index}
                        direction={"row"}
                        alignItems={"center"}
                        justify={"space-between"}
                      >
                        <Grid item>
                          <Grid container direction={"column"}>
                            <Grid item>
                              <div
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  width: "100%",
                                }}
                              >
                                <CustomText
                                  design={classes.fileNameTextStyle}
                                  style={{ wordWrap: "break-word" }}
                                >
                                  {item.FileName}
                                </CustomText>
                              </div>
                            </Grid>
                            <Grid item>
                              <CustomText design={classes.fileSizeTextStyle}>
                                {Helper.convertByte(item.FileSize)}
                              </CustomText>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item>
                          {!_.isEmpty(attachFileBack) ? (
                            <img
                              src={Image.whiteBin}
                              className={classes.deleteIconStyle}
                              onClick={() => onClickDeleteAttachFile("back")}
                            />
                          ) : (
                            false
                          )}
                        </Grid>
                      </Grid>
                    );
                  })
                : false}
            </Grid>
          );
        } else {
          return (
            <Grid
              className={
                isLogin
                  ? classes.uploadNRICPaperisLogin
                  : classes.uploadNRICPaper
              }
            >
              <Grid
                container
                direction={"row"}
                justify={"space-between"}
                alignItems={"center"}
              >
                <Grid item>
                  {!_.isEmpty(attachFileBack)
                    ? attachFileBack.map((item, index) => {
                        return (
                          <div
                            key={index}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <div
                              style={
                                item.FileName.length > 70 &&
                                !window.innerWidth > 600
                                  ? {
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      width: "20rem",
                                    }
                                  : null
                              }
                            >
                              <CustomText
                                design={classes.fileNameTextStyle}
                                style={
                                  item.FileName.length > 70
                                    ? { wordWrap: "break-word" }
                                    : null
                                }
                              >
                                {item.FileName}
                              </CustomText>
                            </div>

                            {/* <CustomText design={classes.fileSizeTextStyle}>
                              {Helper.convertByte(item.FileSize)}
                            </CustomText> */}
                          </div>
                        );
                      })
                    : false}
                </Grid>
                <Grid
                  item
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                  }}
                >
                  {!_.isEmpty(attachFileBack)
                    ? attachFileBack.map((item, index) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginRight: 25,
                            }}
                          >
                            <CustomText design={classes.fileSizeTextStyle}>
                              {Helper.convertByte(item.FileSize)}
                            </CustomText>
                          </div>
                        );
                      })
                    : false}
                  {!_.isEmpty(attachFileBack) ? (
                    <img
                      src={Image.whiteBin}
                      className={classes.deleteIconStyle}
                      onClick={() => onClickDeleteAttachFile("back")}
                    />
                  ) : (
                    false
                  )}
                </Grid>
              </Grid>
            </Grid>
          );
        }
      }
    };

    const renderIsInfoMismatch = () => {
      return (
        <Grid
          container
          direction={"column"}
          spacing={2}
          style={{ paddingLeft: "20%", paddingRight: "20%" }}
        >
          <Grid item xs={12}>
            <CustomText
              design={classes.titleTextStyle}
              style={{ marginBottom: 15 }}
            >
              Upload Document
            </CustomText>
            <CustomText design={classes.descTextStyle} style={{ marginTop: 5 }}>
              PDF/JPG format only and maximum upload size is 10MB.
            </CustomText>
          </Grid>
          <Grid item>
            <CustomText design={classes.titleTextStyle}>NRIC Front</CustomText>
            {!_.isEmpty(attachFileFront)
              ? renderUploadFrontContainer()
              : onUploadAttachFile("front")}
          </Grid>
          <Grid item>
            <CustomText design={classes.titleTextStyle}>NRIC Back</CustomText>
            {!_.isEmpty(attachFileBack)
              ? renderUploadBackContainer()
              : onUploadAttachFile("back")}
          </Grid>
        </Grid>
      );
    };

    const renderNoInfoMismatch = () => {
      return (
        <Grid
          container
          direction={"column"}
          spacing={2}
          style={{ paddingLeft: "20%", paddingRight: "20%", marginBottom: 10 }}
        >
          <Grid item xs={12}>
            <CustomText design={classes.titleTextStyle}>
              Please answer the following details to complete the transaction
            </CustomText>
          </Grid>
          <Grid item xs={12}>
            <CustomTextInput
              //error={_.isEmpty(payorName) && toastMessagePayorName !== ""}
              //errorRootStyle={classes.errorTextInputStyle}
              //inputRef={payorNameRef}
              title={"Payor's Name"}
              textstyle={classes.labelTextInputTextStyle}
              design={classes.textInputContainer}
              value={payorName}
              onChange={onChangePayorName}
              //isVisibleCurrency={false}
              id={"PayorName"}
              //type={type}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomTextInput
              //inputRef={payorNRICRef}
              title={"Their NRIC/FIN No."}
              textstyle={classes.labelTextInputTextStyle}
              design={classes.textInputContainer}
              value={payorNric}
              onChange={onChangeNRIC}
              //onBlur={handleOnBlurInputNRIC}
              isVisibleCurrency={false}
              id={"NRIC"}
              //type={type}
            />
          </Grid>

          <Grid item xs={12}>
            <CustomTextInput
              //inputRef={payorRelationshipRef}
              title={"Their relationship to you"}
              textstyle={classes.labelTextInputTextStyle}
              design={classes.textInputContainer}
              value={payorRelationship}
              onChange={onChangeRelationship}
              isVisibleCurrency={false}
              id={"Relationship"}
              //type={type}
            />
          </Grid>
        </Grid>
      );
    };

    return (
      <CustomPaper
        container
        direction={"column"}
        spacing={2}
        design={classes.paper}
      >
        <Grid item>
          <CustomText
            style={{
              textAlign: "center",
              fontSize: 24,
              // lineHeight: 1.5,
              fontWeight: "800",
              fontFamily: "Muli",
            }}
          >
            One last step
          </CustomText>
        </Grid>
        <Grid item style={{ marginBottom: 30 }}>
          <CustomText
            style={{
              textAlign: "center",
              fontSize: 18,
              // lineHeight: 1.5,
              fontWeight: "400",
              fontFamily: "Muli",
            }}
          >
            Review your payment details.
          </CustomText>
        </Grid>
        <Grid
          container
          direction={"row"}
          style={{
            justifyContent: "space-between",
            marginBottom: 20,
            paddingLeft: "20%",
            paddingRight: "20%",
          }}
        >
          <Grid
            item
            //   style={{ paddingLeft: "20%" }}
          >
            <CustomText
              style={{
                textAlign: "center",
                fontSize: 21,
                // lineHeight: 1.5,
                fontWeight: "bold",
                fontFamily: "Muli",
              }}
              //design={classes.titleDialogTextStyle}
            >
               {orderNumber !== null ? "GI Renewal":"GIRO Enrolment"}
            </CustomText>
          </Grid>
          {/* <Grid
            item
            
          >
            <img src={Image.dbsLogo} />
          </Grid> */}
        </Grid>
        <Grid
          item
          style={{ paddingLeft: "20%", paddingRight: "20%", marginBottom: 10 }}
        >
          <CustomText>Reference No. : {refNo}</CustomText>
        </Grid>
        <Grid item style={{ paddingLeft: "20%", paddingRight: "20%" }}>
          <CustomText>Account No. : {bankAccNo}</CustomText>
        </Grid>

        {orderNumber !== null && <Grid item style={{ paddingLeft: "20%", paddingRight: "20%",marginTop:10 }}>
          <CustomText>Renewal Premium. : {renewalPremium}</CustomText>
        </Grid>}
        {/* <Grid
          item
          style={{ paddingLeft: "20%", paddingRight: "20%", marginTop: 20 }}
        >
          <CustomTextInput
            title={"Account to Pay "}
            textstyle={classes.labelTextInputTextStyle}
            design={classes.textInputContainer}
            fullWidth={true}
            value={bankAccNo}
            disabled={true}
            borderline={false}
          />
        </Grid> */}
        <Grid
          container
          direction={"column"}
          justify={"center"}
          alignItems={"left"}
          spacing={1}
          style={{
            paddingLeft: "20%",
            paddingRight: "10%",
            marginTop: 30,
            marginBottom: 40,
          }}
        >
          <Grid container style={{ justifyContent: "space-between" }}>
            <Grid item style={{ display: "inline-block" }}>
              <CustomText design={classes.titleDialogTextStyle}>
                <span className={classes.boldStyle}>Note:</span> This
                authorization will remain in force until:
              </CustomText>
            </Grid>
          </Grid>

          <Grid item style={{ marginLeft: 10 }}>
            <CustomText design={classes.titleDialogTextStyle}>
              <span style={{ marginRight: 5 }}> &#8226;</span> the bank’s
              written notice is sent to your address last known to the bank;
            </CustomText>
          </Grid>
          <Grid item style={{ marginLeft: 10 }}>
            <CustomText design={classes.titleDialogTextStyle}>
              <span style={{ marginRight: 5 }}> &#8226;</span> upon the bank’s
              receipt of your written revocation; or
            </CustomText>
          </Grid>
          <Grid item style={{ marginLeft: 10 }}>
            <CustomText design={classes.titleDialogTextStyle}>
              <span style={{ marginRight: 5 }}> &#8226;</span> upon the bank’s
              receipt of the notice of expiry from Etiqa
            </CustomText>
          </Grid>
        </Grid>
        {this.state.misMatchYes === true ? renderIsInfoMismatch() : false}
        {this.state.misMatchNo === true ? renderNoInfoMismatch() : false}

        <Grid
          item
          xs={12}
          style={{ paddingLeft: "40%", paddingRight: "40%", marginTop: 20 }}
        >
          <CustomButton
            title={"Enrol"}
            design={
              isLogin ? classes.nextButtonStyleIsLogin : classes.nextButtonStyle
            }
            onClick={this.onClickNext}
          />
        </Grid>
      </CustomPaper>
    );
  };

  render() {
    const { classes } = this.props;
    const { height, width, openCustomToast, isLogin } = this.state;
    const data = enrolGIRONowSelector.getGiroCallBackDataData(
      this.props.getGiroCallBackData
    );
    const bankAccNo = enrolGIRONowSelector.getGiroCallBackDataBankAccountNo(
      data
    );
    const refNo = enrolGIRONowSelector.getGiroCallBackDataDDAReferenceNo(data);
    const tranRefNo = enrolGIRONowSelector.getGiroCallBackDataTransactionReferenceNo(
      data
    );
    const isThirdParty = enrolGIRONowSelector.getGiroCallBackDataIsThirdParty(
      data
    );
    return (
      <div className={isLogin ? classes.rootLogin : classes.root}>
        {/* <CustomEnrolGiroNowV2
            children={this.renderChildren()}
            height={window.innerWidth < 600 ? height + 200 : height}
            width={width}
          /> */}
        {isThirdParty === true ? (
          this.state.misMatchYes === true || this.state.misMatchNo === true ? (
            false
          ) : (
            <MisMatch
              onClickMisMatchYes={this.onClickMisMatchYes}
              onClickMisMatchNo={this.onClickMisMatchNo}
              isLogin={isLogin}
            />
          )
        ) : (
          false
        )}

        {window.innerWidth > 600 ? (
          <AppBar
            position="sticky"
            className={classes.appBar}
            style={{
              background: isLogin
                ? "transparent linear-gradient(143deg, #004880 0%, #0066A7 31%,#007F9C 59%,#008992 80%,#00FFAF 100%) 0% 0% no-repeat padding-box"
                : "#333333",
            }}
          >
            <Toolbar
              className={classes.toolbarStyle}
              style={{
                justifyContent: "space-between",
                //alignItems: "center",
                display: "flex-start",
                flexDirection: "row",
                marginLeft: isLogin ? false : "5em",
              }}
            >
              <img
                src={
                  isLogin
                    ? Image.tiqconnectLogo
                    : Image.nonDirectClientEtiqaLogo
                }
                style={{ width: 112, height: 60 }}
              />
            </Toolbar>
          </AppBar>
        ) : (
          false
        )}

        {window.innerWidth > 600 ? this.renderChildrenV2() : false}
        {window.innerWidth < 601 ? (
          <CustomEnrolGiroNowV2
            children={this.renderChildrenV2()}
            height={height + 700}
            width={width}
          />
        ) : (
          false
        )}
        <CustomToast
          open={openCustomToast}
          handleCloseCustomToast={this.handleCloseCustomToast}
          title={this.state.toastMessage}
          warning
        />
        {this.state.callBackLoading ? <LoadingOverlay loading={true} /> : false}
        {this.props.submitGiroLoading ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
        {this.props.getGiroCallBackDataLoading ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#f4f4f4",
    minHeight: window.screen.height < 800 ? "170vh" : "140vh",
    // backgroundImage:
    //   window.innerWidth < 601 ? false : `url(${Image.enrolGiroBg})`,
    // backgroundSize: window.innerWidth < 601 ? false : `${screenW} ${screenH}`,
    // backgroundPosition: window.innerWidth < 601 ? false : "bottom center",
    // backgroundRepeat: window.innerWidth < 601 ? false : "no-repeat",
    backgroundImage: `url(${Image.enrolGiroBg})`,
    backgroundSize: `${screenW} ${screenH}`,
    backgroundPosition: "bottom center",
    backgroundRepeat: "no-repeat",
  },
  rootLogin: {
    flexGrow: 1,
    backgroundColor: "#f4f4f4",
    minHeight: window.screen.height < 800 ? "170vh" : "140vh",
  },
  imageStyle: {
    width: 57,
    height: 57,
    alignItems: "center",
  },
  bottomImageStyle: {
    width: 20,
    height: 20,
    marginRight: 10,
    color: Color.primaryTextColor,
  },
  labelTextInputTextStyle: {
    fontWeight: "bold",
    ...getFontSize("medium"),
    color: Color.primaryTextColor,
  },
  textInputContainer: {
    height: 45,
    marginTop: 10,
    width: "100%",
  },
  letGoButtonStyle: {
    //width: 120,
    marginTop: 20,
    //marginBottom:"1em"
  },
  buttonTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("medium"),
  },
  bottomTextStyle: {
    ...getFontSize("small"),
    color: Color.primaryTextColor,
    fontFamily: "Muli",
  },
  highLightedTextStyle: {
    color: "#1858b9",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  // renewNowTextStyle: {
  //   ...getFontWeight("800"),
  //   fontSize: 28,
  //   textAlign: "center",
  //   color: "#2c3034",
  //   marginBottom: 10,
  // },
  errorTextStyle: {
    color: "red",
  },

  checked: {},
  optTextStyle: {
    fontSize: 13,
    opacity: 0.7,
  },
  submitPaper: {
    //margin: 20,
    border: "1px solid #C5C5C5",
    borderRadius: " 0",
    //minWidth:500
  },
  failurePaymentPaper: {
    margin: 20,
    [theme.breakpoints.between("sm", "md")]: {
      width: 600,
    },
    [theme.breakpoints.up("lg")]: {
      width: 800,
    },
  },
  appBar: {
    background:
      "transparent linear-gradient(143deg, #004880 0%, #0066A7 31%,#007F9C 59%,#008992 80%,#00FFAF 100%) 0% 0% no-repeat padding-box",
  },
  titleStyle: {
    fontSize: "22px",
    ...getFontWeight("800"),
    marginBottom: 20,
  },
  backButton: {
    //width: 120,
    marginTop: 20,

    borderColor: Color.primaryTextColor,
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    opacity: 0.6,
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
  },
  backButtonTextStyle: {
    fontFamily: "Muli",
    ...getFontSize("medium"),
    ...getFontWeight("bold"),
  },
  paper: {
    // overflow: "auto",
    //backgroundColor: "#f4f4f4",
    //width:"828px",
    marginTop: window.innerWidth < 601 ? false : "6%",
    marginLeft: window.innerWidth < 601 ? false : "25%",
    marginRight: window.innerWidth < 601 ? false : "25%",
  },
  renewNowTextStyle: {
    fontWeight: "bold",
    fontFamily: "Muli",
    fontSize: 22,
    textAlign: "center",
    marginBottom: 10,
    marginTop: 10,
  },
  noteTextStyle: {
    fontFamily: "Muli",
    fontSize: "16px",
    fontWeight: "400",
    color: "#424143",
    textAlign: "center",
  },
  titleDialogTextStyle: {
    fontSize: "12px",
  },
  deleteIconStyle: {
    cursor: "pointer",
    width: "20px",
    height: "20px",
  },
  uploadNRICPaper: {
    padding: theme.spacing(2),
    boxShadow: "0 0 0 0 rgba(0, 0, 0, 0)",
    borderRadius: 5,
    //border: "solid 1px #CCE0DF",
    backgroundColor: "#FEC31A",
    marginTop: 8,
    marginBottom: 0,
    [theme.breakpoints.down("xs")]: {
      minWidth: 150,
      maxWidth: 150,
    },
  },
  uploadNRICPaperisLogin: {
    padding: theme.spacing(2),
    boxShadow: "1px 1px 6px 0  rgba(0, 0, 0, 0.26)",
    borderRadius: 5,
    border: "solid 1px #CCE0DF",
    backgroundColor: "#00B4AF",
    marginTop: 8,
    marginBottom: 0,
    [theme.breakpoints.down("xs")]: {
      minWidth: 150,
      maxWidth: 150,
    },
  },
  titleTextStyle: {},
  nextButtonStyle: {
    backgroundColor: "#FEC31A",
    borderColor: "#FEC31A",
  },
  nextButtonStyleIsLogin: {
    backgroundColor: "#00B4AF",
    borderColor: "#00B4AF",
    color: "#ffffff",
    "&:focus": {
      outline: "none",
    },
    "&:hover": {
      color: Color.black,
      backgroundColor: "#00B4AF",
    },
  },
  fileSizeTextStyle: {
    color: "#fff",
  },
  fileNameTextStyle: {
    color: "#fff",
  },
});

function mapStateToProps(state) {
  return {
    getGiroCallBackData: selector.getGiroCallBackData(state),
    getGiroCallBackDataLoading: selector.getGiroCallBackDataLoading(state),
    getGiroCallBackDataStatus: selector.getGiroCallBackDataStatus(state),
    submitGiroData: selector.submitGiroData(state),
    submitGiroLoading: selector.submitGiroLoading(state),
    submitGiroStatus: selector.submitGiroStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getGiroCallBack: (id) =>
      dispatch(enrolGIRONowAction.getGiroCallBackData(id)),
    submitGiro: (
      ddaRefNo,
      bankTransId,
      payorName,
      payorNric,
      payorRelationship,
      attachedFile,
      isThirdParty,
      isMatch
    ) =>
      dispatch(
        enrolGIRONowAction.submitGiroData(
          ddaRefNo,
          bankTransId,
          payorName,
          payorNric,
          payorRelationship,
          attachedFile,
          isThirdParty,
          isMatch
        )
      ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(GiroReview)));
